import React from "react";
import AmortizationForm from "../../components/AmortizationForm.tsx";

const Amortization: React.FC = () => {
  return (
    <section className="p-5 flex justify-center">
      <div className="container-site">
        <div className="flex flex-wrap gap-5 justify-between items-center mb-4">
          <div>
            <h3 className="heading-2">Amortization</h3>
            <p className="sub-heading-2">Calculate loan schedules and payments</p>
          </div>
        </div>
        <div className="card-glass p-4">
          <AmortizationForm />
        </div>
      </div>
    </section>
  );
};

export default Amortization;
